import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EventsService {
    private _appEvent: BehaviorSubject<any> = new BehaviorSubject(null);
    public appEvent = this._appEvent.asObservable();

    constructor() {}

    triggerEvent(eventData) {
        this._appEvent.next(eventData);
    }
}
